module.exports = __webpack_public_path__ + "img/logo-hansa.a231a0bd.png";